export const PACKAGE_VERSION = "1.6.0";
